import { observer } from 'mobx-react-lite';

import { useFirstOpenTracking } from './useFirstOpenTracking';
import { useFirstVisitAddressModal } from './useFirstVisitAddressModal';
import { useJivoMobileButtonVisibility } from './useJivoMobileButtonVisibility';
import { useRequestCycle } from './useRequestCycle';
import { useRN } from './useRN';
import { useTokenSync } from './useTokenSync';

export default observer(() => {
  useRN();
  useRequestCycle();
  useTokenSync();
  useFirstOpenTracking();
  useFirstVisitAddressModal();
  useJivoMobileButtonVisibility();

  return null;
});
